/* Portuguese Language File */

var currentlanguage = 'pt';

+function ($) {

	/* Portuguese translation for the jQuery dataTable Addon */
	if ('undefined' !== typeof $.fn.dataTable) {
		$.extend( true, $.fn.dataTable.defaults, {
			"oLanguage": {
				"sProcessing":   "A processar...",
				"sLengthMenu":   "Mostrar _MENU_ registos",
				"sZeroRecords":  "Não foram encontrados resultados",
				"sInfo":         "Mostrando de _START_ até _END_ de _TOTAL_ registos",
				"sInfoEmpty":    "Mostrando de 0 até 0 de 0 registos",
				"sInfoFiltered": "(filtrado de _MAX_ registos no total)",
				"sInfoPostFix":  "",
				"sSearch":       "Procurar:",
				"sUrl":          "",
				"oPaginate": {
				    "sFirst":    "Primeiro",
				    "sPrevious": "Anterior",
				    "sNext":     "Seguinte",
				    "sLast":     "Último"
				}
			}
		});
	}

	// Extra APT validator translations
	if ('undefined' !== typeof $.validator) $.extend($.validator.messages, {
		// Extra for apt
		credit_limit: "The credit limit should be between 250k and 150M.",
		grace_holiday_period: "The grace period should be lower than the term in months.",
		term_grace_leasing: "The term minus grace period should always be a multiple of payment frequency.",
		max_term_leasing: "The term minus grace period should not exceed 240 months (20 years).",
		max_term_factoring: "The term should not exceed 1200 months (100 years).",
		net_principal_amount: "The sum of down payment and residual value should be lower than the net principle amount.",
		zero: "This field must be greater than zero."
	});

}(jQuery);
